import React from 'react'
import { RouterProvider } from 'react-router-dom'
import { ChakraProvider } from '@chakra-ui/react'
import { router } from './routes'
import theme from './utils/chakraSetup'

function App() {
  return (
    <ChakraProvider theme={theme} >
      <RouterProvider router={router} />
    </ChakraProvider>
  )
}

export default App
